import { render } from "./money_from_money_launderer.vue?vue&type=template&id=dc9bfdcc"
import script from "./money_from_money_launderer.vue?vue&type=script&lang=js"
export * from "./money_from_money_launderer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__